var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conf"},[_c('div',{staticClass:"fongsaig"},[_c('img',{attrs:{"src":_vm.image,"width":"753.9px","height":"413.25px"}}),_c('div',{staticClass:"font"},[_vm._v("无法访问此网站")]),_c('div',{staticClass:"navtobtn",on:{"click":_vm.navtoback}},[_vm._v("跳转首页")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }